// src/i18n.ts
import { createI18n } from 'vue-i18n';

function loadLocaleMessages(): Record<string, any> {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const locales = require.context('@/locales', true, /\.json$/i);

  const messages: Record<string, any> = {};
  locales.keys().forEach((key: string) => {
    const matched = key.match(/([^/]+)\.json$/i);
    if (!matched?.[1]) return;

    const locale = matched[1];
    const mod = locales(key);
    messages[locale] = mod?.default ?? mod;
  });

  return messages;
}

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  missingWarn: false,
  fallbackWarn: false
});

export default i18n;
